module.exports = __webpack_public_path__ + "img/banner-00.9211f933.png";